import styles from './Scam.module.css';

import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Line } from '@antv/g2plot';
import { Form, Input, Statistic, Drawer, Card, Row, Col, Spin, PageHeader, Button, Tooltip, List } from 'antd';

import { ReloadOutlined, MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';

import { getScamKeywords, updateScamKeywords, getPotentialScamForms } from 'store/ducks/scam.js';

const Scam = () => {
  const dispatch = useDispatch();

  const keywords = useSelector((state) => state.scam.scamKeywords);
  const scamForms = useSelector((state) => state.scam.scamForms);
  const loadingKeywords = useSelector((state) => state.scam.getScamKeywords.loading);
  const loadingForms = useSelector((state) => state.scam.getPotentialScamForms.loading);

  const [showEditKeywords, setShowEitKeywords] = useState(false);

  const reload = () => {
    dispatch(getPotentialScamForms());
  };

  const onKeywordsUpdateFinish = (values) => {
    const keywords = [...new Set(values.keywords)].filter((value) => value);

    setShowEitKeywords(false);
    dispatch(updateScamKeywords(keywords));
  };

  const editKeywords = () => {
    dispatch(getScamKeywords());
    setShowEitKeywords(true);
  };

  useEffect(() => {
    dispatch(getPotentialScamForms());
  }, []);

  const initialFields = [{ name: ['keywords'], value: keywords || [] }];

  return (
    <>
      <PageHeader
        title="Scam Detection"
        extra={[
          <Button onClick={() => editKeywords()}>Edit Keywords</Button>,
          <Button onClick={() => reload()}>
            <ReloadOutlined />
          </Button>
        ]}
        style={{ border: '1px solid #f0f0f0', background: '#fff', margin: '0 0 15px 0' }}
      />

      <Card style={{ width: '100%' }}>
        <List
          dataSource={scamForms}
          renderItem={(item) => (
            <List.Item key={item._id}>
              <List.Item.Meta
                title={
                  <Link to={`/forms/${item._id}`} target="_blank">
                    {item.name}
                  </Link>
                }
              />
              <div>
                <Link to={`/users/${item.owner._id}`} target="_blank">
                  {item.owner.email}
                </Link>
              </div>
            </List.Item>
          )}></List>
      </Card>

      <Drawer
        title="Keywords"
        placement="right"
        closable={true}
        onClose={() => setShowEitKeywords(false)}
        destroyOnClose={true}
        width={400}
        visible={showEditKeywords}>
        <Spin spinning={loadingKeywords || loadingForms} size="large">
          <Form name="scamKeywords" fields={initialFields} onFinish={onKeywordsUpdateFinish}>
            <Form.List name="keywords">
              {(fields, { add, remove }) => (
                <div>
                  {fields.map((field, index) => (
                    <Form.Item label="" required={false} key={field.key}>
                      <Form.Item
                        {...field}
                        validateTrigger={['onChange', 'onBlur']}
                        rules={[
                          {
                            required: false,
                            whitespace: false
                          }
                        ]}
                        noStyle>
                        <Input placeholder="keyword" style={{ width: '90%', marginRight: 8 }} />
                      </Form.Item>
                      {fields.length > 1 && <MinusCircleOutlined onClick={() => remove(field.name)} />}
                    </Form.Item>
                  ))}
                  <Form.Item>
                    <Button type="dashed" onClick={() => add()} style={{ width: '90%' }}>
                      <PlusOutlined /> Add keyword
                    </Button>
                  </Form.Item>
                </div>
              )}
            </Form.List>

            <Form.Item>
              <Button type="primary" htmlType="submit">
                Save
              </Button>
            </Form.Item>
          </Form>
        </Spin>
      </Drawer>
    </>
  );
};

export default Scam;
